import React from 'react';
import { useIntl } from 'react-intl';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import Loader from '../../../../core/components/Loader';

const modalBodyStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '2rem',
};

const loaderOptions = { width: '80px', height: '80px' };

export interface DetergentLoadingModalProps {
  isOpen: boolean;
  hide: () => void;
}

const DetergentLoadingModal = React.memo(({ isOpen, hide }: DetergentLoadingModalProps) => {
  const intl = useIntl();
  const title = intl.formatMessage({ id: 'creatingDetergents' });
  const message = intl.formatMessage({ id: 'creatingDetergentsMessage' });

  return (
    <Modal
      isOpen={isOpen}
      toggle={hide}
      backdrop="static"
      keyboard={false}
      className="modal-content"
    >
      <ModalHeader>{title}</ModalHeader>
      <ModalBody style={modalBodyStyle}>
        <Loader options={loaderOptions} />
        <div style={{ marginTop: '1rem', textAlign: 'center' }}>{message}</div>
      </ModalBody>
    </Modal>
  );
});

DetergentLoadingModal.displayName = 'DetergentLoadingModal';

export default DetergentLoadingModal;
